import { Box, Grid } from "@mui/material";
import PureModal from "components/PureModal";
import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useIntl } from "react-intl";

export default function TokensModal({
  open,
  handleClose,
  closeBtn = false,
  tokens,
  ...props
}) {
  const { formatMessage } = useIntl();

  return (
    <PureModal
      open={open}
      closeBtn={closeBtn}
      onClose={handleClose}
      sx={{ zIndex: 10000 }}
      maxWidth="520px"
      {...props}
    >
      <Box
        p="24px 24px 24px 32px"
        borderBottom="1px solid #E6E6E6"
        fontSize={20}
        fontWeight={700}
        className="item-flex"
        justifyContent="space-between"
      >
        <Box>
          {formatMessage({ id: "global.filterCriteria.currentHoldings" })}
        </Box>
        <i
          className="meta-crm-icon-ic_cancel font-size-20"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </Box>
      <Box p="24px 32px 48px" maxHeight={"328px"} overflow="auto">
        <Box color="#777" fontSize={12} mb="16px">
          {formatMessage({ id: "global.commonWord.total" })} ({tokens?.length})
        </Box>
        <Box className="item-flex" gap="8px 12px" fontSize={12} color="#222">
          {tokens?.map((token, index) => (
            <Box key={index} className="item-flex">
              <Box
                component={"img"}
                src={token.src}
                alt={token.label}
                sx={{ width: 20, height: 20, borderRadius: "50%", mr: "4px" }}
              />
              <Box>{token.label}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    </PureModal>
  );
}
